import React, { useEffect } from 'react'
import { Drawer, Card, Button, Form, Row, Col, notification } from 'antd'
import { formItemLayout } from '../../../components/_utils/appUtils'
import { useDispatch } from 'react-redux'
import GetEachFormFields from '../../../components/_utils/appFormUtils'
import { DeleteAbstractViewFxn } from '../views/actions'
import moment from 'moment'

const DeleteAbstractDrawer = (props) => {
  let {
    form: { getFieldDecorator, setFieldsValue },
    visible,
    onClose,
    abstract
  } = props

  const dispatch = useDispatch()

  useEffect(() => {
    setTimeout(() => {
      setFieldsValue({
        deletedDate: moment()
      })
    }, 500)
  }, [])

  const inputSchema = {
    fields: [
      {
        label: 'Delete Date',
        key: 'deletedDate',
        required: true,
        type: 'date'
      },
      {
        label: 'Special Note',
        key: 'deleteReason',
        required: true,
        span: 24,
        type: 'textarea'
      }
    ]
  }

  const handleSubmit = e => {
    const { form, abstract } = props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        valData.abstractId = abstract._id
        valData.status = 'Deleted'

        let { success } = await dispatch(DeleteAbstractViewFxn(valData))

        if (success) {
          onClose()
          // Ensure you trigger the reload action for abstracts
          dispatch({ type: 'START_LOAD_ABSTRACT' })
        }
      } else {
        notification.error({
          message: 'Required',
          description: 'Fill all required fields.'
        })
      }
    })
  }

  return (
    <Drawer
      title={`Delete Abstract | Abstract ID: ${abstract.abstractNo}`}
      width={'40%'}
      visible={visible}
      placement='right'
      onClose={onClose}>
      <Card>
        <Form onSubmit={handleSubmit} hideRequiredMark className={'inputForm'}>
          <Row gutter={16}>
            {inputSchema.fields.map((item, key) => (
              <Col span={item.span ? item.span : 12} key={key}>
                <GetEachFormFields
                  getFieldDecorator={getFieldDecorator}
                  item={item}
                  formItemLayout={formItemLayout}
                />
              </Col>
            ))}
            <Col span={24}>
              <Form.Item style={{ marginTop: 40 }}>
                <Button type='primary' htmlType='submit'>
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </Drawer>
  )
}

const WrappedForm = Form.create()(DeleteAbstractDrawer)
export default WrappedForm
